var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "supsis-context-menu",
          style: _vm.menuStyle,
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "context-menu-item",
              class: {
                danger: item.danger,
                disabled: item.disabled,
                divider: item.divider,
              },
              on: {
                click: function ($event) {
                  !item.disabled && !item.divider && _vm.onItemClick(item)
                },
              },
            },
            [
              !item.divider
                ? [
                    item.icon
                      ? _c("i", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(item.icon)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.label))]),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }